import { store } from '@/store'
import Tenant from '@/types/Tenant.interface';
import User from '@/types/User.interface';
import moment from 'moment'

const intercomIdentify = (user: User): void => {
    // Boot Intercom with user info for configured tours and support messages
    // (hide the Intercom FAB until needed)
    const userCreatedTimestamp = moment(user.created_at).unix()

    //  Identify the user and boot up intercom
    window.Intercom('boot', {
        app_id: window.INTERCOM_APP_ID,
        email: user.email,
        phone: user.mobilephone,
        name: user.firstname,
        user_id: user.id,
        created_at: userCreatedTimestamp,
        hide_default_launcher: true,
        custom_launcher_selector: '#messagedesk-help-button'
    })
}

const intercomRegistrationEvent = (user: User): void => {
    //  Intercom event data
    const data = {
        email: user.email,
        phone: user.mobilephone,
        name: user.firstname
    }

    //  Report event to Intercom
    window.Intercom('trackEvent', 'intercomRegistrationComplete', data)
}

const mobileIntercomIdentify = (user: User): void => {
    //  Boot intercom with user info
    const userCreatedTimestamp = moment(user.created_at).unix()

    //  Intercom event data
    const data = {
        email: user.email,
        phone: user.mobilephone,
        name: user.firstname
    }

    //  Identify our user
    //  @ts-ignore
    intercom.registerIdentifiedUser({
        ...data,
        user_id: user.id,
        created_at: userCreatedTimestamp
    })

    //  @ts-ignore Hide our launcher
    //  This line is supposed to hide our Intercom button
    //  but for some reason, this makes it appear on Android, very weird
    // intercom.setLauncherVisibility('HIDDEN')

    console.log("MOBILE IDENTIFIED FOR INTERCOM")
}

const mobileIntercomRegistrationEvent = (user: User): void => {
    //  Intercom event data
    const data = {
        email: user.email,
        phone: user.mobilephone,
        name: user.firstname
    }

    //  Report event to Intercom
    //  @ts-ignore
    intercom.logEvent('intercomRegistrationComplete', data)
}

export default {
    //  Handles the ApplicationLoaded event
    onApplicationLoaded(): void {
        store.getters.appDebug && console.log('INTERCOM: onApplicationLoaded')

        //  Set the global Intercom app id
        window.INTERCOM_APP_ID = process.env.VUE_APP_INTERCOM_APP_ID;

        // @ts-ignore - Initialize Intercom (product tours & support)
        (function () { var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', w.intercomSettings); } else { var d = document; var i = function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/' + window.INTERCOM_APP_ID; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (document.readyState === 'complete') { l(); } else if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); } } })();

        // Opens our intercom window automatically so users can see checklist
        this.onUserLogin()
    },
    //  Handles the TenantSet event
    onTenantSet(tenant: Tenant): void {
        store.getters.appDebug && console.log('INTERCOM: onTenantSet')
        //  Get the currently authenticated user
        const user = store.getters.user

        //  Check if this user is the admin of this tenant
        const isAdmin = user.id === tenant.admin_user_id

        //  Check if we are on the mobile app
        const isApp = store.getters.isApp
        console.log('changed stuff')

        //  Identify and boot for this user
        intercomIdentify(user)

        //  If user id matches tenant admin id, update intercom
        if (isAdmin) window.Intercom('update', { 'isAdmin': true })

        //  If we are on mobile app, handle it
        if (isApp) {
            //  Identify the user
            mobileIntercomIdentify(user)

            console.log("ABOUT TO REGISTER FOR PUSH W/ INTERCOM")
            //  Register them for push notifications
            //  @ts-ignore (required because Cordova package has no namespace)
            intercom.registerForPush()
            console.log("DONE REGISTERING")

            //  @ts-ignore - IF admin, then update this user
            if (isAdmin) intercomIdentify.updateUser({ 'isAdmin': true })
        }
    },
    //  Handles the UserRegistered event
    onUserRegistered(user: User): void {
        //  Check if we are on the mobile app or not
        const isApp = store.getters.isApp

        //  Identify our intercom user
        intercomIdentify(user)
        //  Start intercom automations
        intercomRegistrationEvent(user)

        //  If we are, then do mobile intercom
        if (isApp) {
            //  Identify for mobile users too
            mobileIntercomIdentify(user)
            //  STart intercom automations for mobile
            mobileIntercomRegistrationEvent(user)
        }
    },
    // Handles Intercom opening checklist 
    onUserLogin(): void {
        // Don't open the intercom checklist if the user isn't trialing
        if (!store.getters.trialing) {
            return
        }

        // Our QA version, need to change to prod version after testing 
        window.Intercom('startChecklist', 27800763)
    }

}